export type GlobalCheckFunction = () => boolean;

export const loadScript = (url: string, key: string | GlobalCheckFunction) => {
	return new Promise((resolve, reject) => {
		if (key === undefined) {
			console.warn("[ScriptLoader] No key passed into loadScript");
			resolve(true);
		}
		if (
			(typeof key === "function" && !key()) ||
			(typeof key === "string" && !window[key])
		) {
			const script = document.createElement("script");
			script.src = url;
			script.async = true;
			script.defer = true;
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild(script);
			return;
		}

		resolve(true);
	});
};

export const waitForGlobal = (key: string) => {
	if (window[key]) {
		return window[key];
	}
	setTimeout(() => {
		waitForGlobal(key);
	}, 100);
};

export default loadScript;
